import { render, staticRenderFns } from "./SessionsBuilder.vue?vue&type=template&id=324b3097&"
import script from "./SessionsBuilder.vue?vue&type=script&lang=js&"
export * from "./SessionsBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SessionsBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports